import React, {Component} from 'react';
import {connect} from 'react-redux';
import {setActiveButton} from '../state/activeButton';
import {setPuzzleUrl} from '../state/puzzleUrl';
import {expandRightMenu, hideRightMenu} from "../state/expandRightMenu";
import {postPuzzle} from '../api';
import {LanguageContext} from "../App";

class RightMenuButton extends Component {
    constructor(props) {
        super(props);

        this.handleClick = (language) => {
            let dataToShare = Object.assign({}, {
                'past': [],
                'present': this.props.puzzleToShare['present'].map(puzzle => ({...puzzle, path: puzzle.path[language] || puzzle.path})),
                'future': []
            });

            postPuzzle(dataToShare).then(data => {
                    let url = document.location.href.split('/');
                    if (url[url.length - 1] === "") {
                        url.splice(-1, 1);
                    }
                    if (url[url.length - 1].match(new RegExp('^[a-z0-9]{8}$', 'gi'))) {
                        url.splice(-1, 1);
                    }
                    url.push(data.puzzle.hash);
                    url = url.join('/');
                    window.history.pushState(null, null, url);
                    let newUrl = 'www.puzzle.uczymydzieciprogramowac.pl/' + language + '/' + data.puzzle.hash;
                    this.props.setPuzzleUrl(newUrl)
                }
            );
            if (this.props.isExpandedRightMenu.expanded && this.props.activeButtonName === this.props.id) {
                this.props.hideRightMenu();
                setTimeout(() => this.props.setActiveButton({name: ''}), 700)
            } else {
                this.props.expandRightMenu(this.props.id);
                this.props.setActiveButton({name: this.props.id});
            }
        };
    }

    render() {
        let activeClass = this.props.activeButtonName === this.props.id ? ' active-button' : '';
        return (
            <LanguageContext.Consumer>
                {({language}) =>
                    <button className={"right-menu-button" + activeClass} onClick={() => { this.handleClick(language['jezyk']); }}>
                        <div className="button-content">
                            <img className="right-menu-button-img" src={this.props.src} alt={this.props.name}/>
                            <p>{this.props.name}</p>
                        </div>
                    </button>
                }
            </LanguageContext.Consumer>
        )
    }
}

export default connect(state => ({
        activeButtonName: state.activeButton.name,
        isExpandedRightMenu: state.expandRightMenu,
        puzzleToShare: state.puzzlesOnBoard
    }),
    {setActiveButton, expandRightMenu, hideRightMenu, setPuzzleUrl}
)(RightMenuButton)



// WEBPACK FOOTER //
// ./src/RightMenu/RightMenuButton.js